var map = {
	"./1.png": "5f20",
	"./2.png": "7549",
	"./3.png": "efc6",
	"./5.png": "3638",
	"./6.png": "d1bc",
	"./ARA.png": "b49d",
	"./CZE.png": "24db",
	"./DNK.png": "64a0",
	"./ENG.png": "a1ca",
	"./EST.png": "8508",
	"./FIN.png": "767c",
	"./FRE.png": "ef42",
	"./GER.png": "16bf",
	"./HRV.png": "5a23",
	"./HUN.png": "2d4d",
	"./ISR.png": "fe48",
	"./ITA.png": "79c0",
	"./LTU.png": "53b8",
	"./LVA.png": "9307",
	"./MDR.png": "098f",
	"./NED.png": "3850",
	"./NOR.png": "dab7",
	"./POL.png": "4838",
	"./PRT.png": "4568",
	"./ROU.png": "09a2",
	"./RUS.png": "fdfd",
	"./SPA.png": "c960",
	"./SVK.png": "3132",
	"./SVN.png": "4be3",
	"./SWE.png": "c1ae",
	"./VNM.png": "19c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d488";